function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_2-Dashboard_Design-Final-Copy-2",
  "data-name": "2-Dashboard_Design-Final-Copy-2",
  transform: "translate(-32 -274)"
}, /*#__PURE__*/React.createElement("g", {
  id: "car-steering-wheel",
  transform: "translate(32 274)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,2.25a6.744,6.744,0,0,1,6.337,4.5H2.663A6.744,6.744,0,0,1,9,2.25Zm0,7.875A1.125,1.125,0,1,1,10.125,9,1.125,1.125,0,0,1,9,10.125ZM2.25,9c3.074,0,5.564,2.962,5.616,6.636A6.749,6.749,0,0,1,2.25,9Zm7.884,6.636C10.186,11.962,12.676,9,15.75,9A6.749,6.749,0,0,1,10.134,15.636Z"
})));

var SvgDrivers = function SvgDrivers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrivers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drivers.e22e0593.svg";
export { ForwardRef as ReactComponent };